<script>
	import Transform from '../data/Transform.js';
	import Vector2D from '../data/Vector2D.js';
	import Player from '../data/Player.js';
	import Enemy from '../data/Enemy.js';
	import Room from '../data/Room.js';
	import {colors} from '../stores.js';

	let player = new Player;
	player.transform.position = new Vector2D(2, 2);
	let noise = getNoise();
	let room = new Room;
	let enemies = [
		// new Enemy (player.transform, new Vector2D (2, 7), room),
		// new Enemy (player.transform, new Vector2D (8, 7)),
		// new Enemy (player.transform, new Vector2D (10, 7)),
		// new Enemy (player.transform, new Vector2D (12, 7)),
		// new Enemy (player.transform, new Vector2D (14, 7)),
	];


	// Update. As often as possible
	let lastUpdate = 0;
	const update = timestamp => {
		let delta = (timestamp - lastUpdate) / 16;
		player = player.update(delta);
		enemies = enemies.map(enemy => enemy.update(delta));
		lastUpdate = timestamp;
		window.requestAnimationFrame(update);
    }
	window.requestAnimationFrame(update);

	// Fixed Update. ~60 times per second
	setInterval(() => {
		player.fixedUpdate(room);
		enemies.forEach(enemy => enemy.fixedUpdate(enemies));
	}, 16);

</script>

<svelte:window on:keydown={event => player.keys.add(event.key.toLowerCase())}
	on:keyup={event => player.keys.delete(event.key.toLowerCase())} />

<div class="h-screen v-screen bg-black flex flex-col justify-center">
	<svg class="w-full border-4 border-gray-900" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 9">
		<symbol id="enemy" width=".5" height=".5" viewBox="0 0 .5 .5" overflow="visible" >
			<path d="M .25 .25 l -2 -2 a 3 3 0 0 1 4 0 z" stroke="var(--sight-color)" stroke-width="0.1" fill="none" />
			<rect x="0" y="0" width=".5" height =".5" fill="{$colors.green[500]}" />
		</symbol>
		<rect x="0" y="0" width="16" height="9" fill="{$colors.gray[900]}" />
		{#each room.grid as space, index}
			<rect x="{index % 16}" y="{Math.floor(index / 16)}" width="1" height="1"
				fill="{space ? $colors.gray[900] : $colors.gray[800]}" stroke="{$colors.gray[900]}" stroke-width=".03" />
				<!-- {#if !space}
					<g transform="rotate({enemies[0].layout[index].degrees} {(index % 16) + .5} {Math.floor(index / 16) + .5})">
						<line stroke-width=".1" stroke="black" x1="{(index % 16) + .5}" y1="{Math.floor(index / 16) + .2}"
							x2="{(index % 16) + .2}" y2="{Math.floor(index / 16) + .8}" />
						<line stroke-width=".1" stroke="black" x1="{(index % 16) + .5}" y1="{Math.floor(index / 16) + .2}"
							x2="{(index % 16) + .8}" y2="{Math.floor(index / 16) + .8}" />
					</g>
				{/if} -->
		{/each}
		{#each enemies as enemy}
			<use xlink:href="#enemy" x="{enemy.transform.position.x - .25}"  y="{enemy.transform.position.y - .5}"
				style="--sight-color: {enemy.targetInRange ? $colors.red[500] : $colors.yellow[500]}"
    			transform="rotate({enemy.transform.velocity.degrees} {enemy.transform.position.x} {enemy.transform.position.y})" />
		{/each}

		<g transform="rotate({player.transform.velocity.degrees} {player.transform.position.x} {player.transform.position.y})">
			<circle cx="{player.transform.position.x}" cy="{player.transform.position.y}" r=".25" fill="{$colors.blue[500]}" />
			<line x1="{player.transform.position.x}" y1="{player.transform.position.y}"
				x2="{player.transform.position.x}" y2="{player.transform.position.y - .5}" stroke-width=".1" stroke="black" />
		</g>
		<!-- <text x="5" y="7" style="font: 1px sans-serif;"> {$time} </text> -->
	</svg>
</div>
